import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { GetCanceledSubscriptionsInput } from '../domain/dtos/get-canceled-subscriptions-input'
import { GetCanceledSubscriptionsOutput } from '../domain/dtos/get-canceled-subscriptions-output'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'
import { GetOfferIds } from './get-offer-ids'

export class GetCanceledSubscriptions {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(
    input: GetCanceledSubscriptionsInput,
    signal?: AbortSignal,
  ): Promise<GetCanceledSubscriptionsOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.BFF_WEB_URL}/receiver/summary/subscriptions/canceled`,
      body: this.makeBody(input),
      signal,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new GeneralError()
  }

  private makeBody(input: GetCanceledSubscriptionsInput) {
    const offerIds = new GetOfferIds().execute({ offerIds: input.offerIds, offers: input.offers })

    const body = {
      startDate: input.startDate,
      endDate: input.endDate,
      offerIds,
    }

    return body
  }
}
